// extracted by mini-css-extract-plugin
export var radioInputRow = "D_tR";
export var radioInputColumn = "D_tS";
export var inputOptionRow = "D_r5";
export var inputOptionColumn = "D_r6";